import React, {useState} from 'react';
import './App.css';
import {Enviar_Mensaje, GuardarVar, CambiaTopico} from './Funciones';
import { Button, Container, InputGroup, FormControl, Form, Alert} from 'react-bootstrap';



 
function App() {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }else{
      event.preventDefault();
      event.stopPropagation();
      Enviar_Mensaje();
    }
      setValidated(true);
  };


  return (
    <>
      <Container className="text-center my-3"><h1>Mensajes MQTT</h1></Container>
      <Container className="text-center my-3">
        <Container>
          <Form noValidate validated={validated} onChange={GuardarVar} onSubmit={handleSubmit}>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>Topic</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl required name="Topico"/>
            </InputGroup>
            <InputGroup size="sm" className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text>Value</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl name="Value" />
            </InputGroup>
            <Button type="submit">Enviar</Button>
          </Form>
        </Container>
        <Container className='my-3'>
          <Form>
            <Form.Check type="switch"
              id="kmpdata/1"
              label="Topico: kmpdata/1"
              name="kmpdata/1"
              onChange={CambiaTopico} />
            <Form.Check type="switch"
              id="kmpdata/2"
              label="Topico: kmpdata/2"
              name="kmpdata/2"
              onChange={CambiaTopico} />
          </Form>
        </Container>
        <Alert variant='success' className='my-3' id='Alerta'>Mensajes de Entrada</Alert>
      </Container>
    </>
  );
}

export default App;
